import React from 'react';
import './App.css';

const Greeting = () => {
  return (
    <div className="greeting-container">
      <h1 className="sinhala-text">
              <img src="./images/greeting.png" alt="ආයුු‌බෝවන්!" className="sinhala-image" /> <span className="english-text">Ayubowan!</span></h1>
      <h2 className="welcome-text">Welcome to Wasala Tours</h2>
      <p className="greeting-para"> Wasala Tours (Pvt) Ltd is a proudly Sri Lankan tourism company founded in 2014 by two passionate and dedicated young entrepreneurs. What began as a small-scale venture has steadily grown over the years, officially becoming a registered private limited company in 2018.
                                              Today, Wasala Tours stands as a trusted name in the travel and hospitality industry of Sri Lanka.</p>
    </div>
  );
};

export default Greeting;
